import ReactComponent from '@/assets/icons/stamp.svg?react';
import { CSSProperties } from 'react';

export interface UploadIconProps {
    color?: string;
    height?: number;
    style?: CSSProperties;
    className?: string;
    onClick?: () => void;
}

const Icon = ({
    color = '#757A7B',
    height = 20,
    style,
    className,
    onClick,
}: UploadIconProps) => {
    return (
        <ReactComponent
            height={height}
            fill={color}
            stroke={color}
            style={style}
            className={className}
            onClick={onClick}
        />
    );
};
export default Icon;
